import { render } from "./add-staff.vue?vue&type=template&id=5e7e3ac1&scoped=true"
import script from "./add-staff.vue?vue&type=script&lang=js"
export * from "./add-staff.vue?vue&type=script&lang=js"

import "./add-staff.vue?vue&type=style&index=0&id=5e7e3ac1&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7e3ac1"]])

export default __exports__